import { Injectable } from '@angular/core';
import { TransactionCreate } from '../../dtos/transaction/transaction-create';
import { TransactionData } from '../../interfaces/transaction/transaction-data';

@Injectable({
  providedIn: 'root',
})
export class TransactionDataToTransactionCreateMapperService {

  public map(transactionData: TransactionData, transactionType: 'CAPTURE' | 'REFUND' | 'VOID' | 'CREDIT'): TransactionCreate {

    if (transactionType === 'CAPTURE' || transactionType === 'VOID') return null;

    return {
      refundAmount: transactionType === 'REFUND' ? transactionData.refundAmount * 100 : undefined,
      creditAmount: transactionType === 'CREDIT' ? transactionData.creditAmount * 100 : undefined,
      currency: (transactionType === 'REFUND' || transactionType === 'CREDIT') ? transactionData.currency : undefined,
    }

  }
}
